import React, { createContext, useContext, useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import apiService from './services/apiService';

// Lazy load pages for better performance
const Homepage = lazy(() => import('./pages/Homepage'));
const MovieDetail = lazy(() => import('./pages/MovieDetail'));
const Programming = lazy(() => import('./pages/Programming'));
const EventiRassegne = lazy(() => import('./pages/EventiRassegne'));
const RassegnaDetail = lazy(() => import('./pages/RassegnaDetail'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const AdminPanelPage = lazy(() => import('./pages/AdminPanel'));

// Contesto globale per i dati della programmazione
const ProgrammazioneContext = createContext();

export const useProgrammazione = () => {
  const context = useContext(ProgrammazioneContext);
  if (!context) {
    throw new Error('useProgrammazione deve essere usato all\'interno di ProgrammazioneProvider');
  }
  return context;
};

function App() {
  const [programmazione, setProgrammazione] = useState([]);

  // Load data from API on component mount
  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await apiService.getProgrammazione();
        setProgrammazione(data.movies || []);
      } catch (error) {
        console.error('Error loading programmazione:', error);
        // Set empty array as fallback
        setProgrammazione([]);
      }
    };
    
    loadData();
  }, []);

  const contextValue = {
    programmazione,
    setProgrammazione
  };

  return (
    <HelmetProvider>
      <AuthProvider>
        <ErrorBoundary>
          <ProgrammazioneContext.Provider value={contextValue}>
            <Router>
            <ScrollToTop />
            <div className="min-h-screen bg-cinema-ivory">
              <Header />
              <main>
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/movie/:title" element={<MovieDetail />} />
                    <Route path="/programmazione" element={<Programming />} />
                    <Route path="/eventi-rassegne" element={<EventiRassegne />} />
                    <Route path="/rassegna/:slug" element={<RassegnaDetail />} />
                    <Route path="/eventi" element={<div className="pt-20 p-8 text-center"><h1 className="text-4xl font-bold">Eventi - In costruzione</h1></div>} />
                    <Route path="/abbonamenti" element={<div className="pt-20 p-8 text-center"><h1 className="text-4xl font-bold">Abbonamenti - In costruzione</h1></div>} />
                    <Route path="/contatti" element={<div className="pt-20 p-8 text-center"><h1 className="text-4xl font-bold">Contatti - In costruzione</h1></div>} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            
                    <Route path="/admin" element={
                      <ProtectedRoute requireAdmin={true}>
                        <AdminPanelPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/admin/:tab" element={
                      <ProtectedRoute requireAdmin={true}>
                        <AdminPanelPage />
                      </ProtectedRoute>
                    } />
                  </Routes>
                </Suspense>
              </main>
              <Footer />
            </div>
            </Router>
          </ProgrammazioneContext.Provider>
        </ErrorBoundary>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;